import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

import { CustomNumberFormat } from '../../commons/CustomNumberFormat';
import { CustomSkeletonElement } from '../../commons/CustomSkeletonElement';
import { PreparedCalculateData } from '../../../models/Calculate';

interface SubmissionLabel {
  calculation: PreparedCalculateData | null;
  isPaidServiceSuspension: boolean;
  isLoaded: boolean;
  isShowPeriod: boolean;
}

const SubmissionLabel: FC<SubmissionLabel> = ({ calculation, isPaidServiceSuspension, isLoaded, isShowPeriod }) => {
  const { t } = useTranslation();
  const { pay_amount: payAmount, view } = calculation ?? {};
  const isShowTotalSum = !(isPaidServiceSuspension && !view?.ex_amo.length);

  return (
    <div className="total">
      {isShowTotalSum ? (
        <div className="info-row">
          <article className="payment__content__label">{t('servicePayment.sum')}</article>
          {isLoaded ? (
            <div className="payment__content__value payment__content__value__strong">
              <CustomNumberFormat value={payAmount && isShowPeriod ? payAmount : 0} suffix={t('common.uah')} />
            </div>
          ) : (
            <CustomSkeletonElement
              skeletonContainerClassName="checkout-sum-skeleton"
              skeletonChildrenClassName="checkout-sum-skeleton__btn skeleton"
              childrenCount={1}
            />
          )}
        </div>
      ) : null}
      {isShowPeriod ? (
        <>
          {isLoaded ? (
            <span className="payment__content__date">
              {t('paymentHistory.paymentPeriod', {
                from: view && DateTime.fromSeconds(view.fts).setZone('Europe/Kiev').toFormat('dd.MM.yyyy'),
                to: view && DateTime.fromSeconds(view.tts).setZone('Europe/Kiev').toFormat('dd.MM.yyyy'),
              })}
            </span>
          ) : (
            <CustomSkeletonElement
              skeletonContainerClassName="submission-period-skeleton"
              skeletonChildrenClassName="submission-period-skeleton__btn skeleton"
              childrenCount={1}
            />
          )}
        </>
      ) : null}
    </div>
  );
};

export default memo(SubmissionLabel);
